import { Injectable } from '@angular/core';
import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';

@Injectable()
export class AdministraMarcasService {

  constructor(private router: Router, public http: Http) { }

  marcas: any = [];

  /**
   * Obtiene una lista de blogs
   */
  obtieneMarcas() {

      let promesa = new Promise((resolve, reject) => {
        let url = URL_SERVICIOS + '/categorias/obtieneListaCategorias/1';
        this.http.get(url)
          .map(resp => resp.json())
          .subscribe(data => {
            this.marcas = data.resultado;
            console.info("::: obtieneMarcas :::");
            console.info(this.marcas);
            resolve(true);
          });
      });
      return promesa;

  }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/administra-marcas.service.ts